"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getPageViewCategoryAccordingToTheStack", {
    enumerable: true,
    get: function() {
        return getPageViewCategoryAccordingToTheStack;
    }
});
var getPageViewCategoryAccordingToTheStack = function() {
    var _document_body;
    if (typeof window === "undefined") {
        return "page_view_next";
    }
    // SPA
    if (((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.dataset.spaPage) === "true") {
        return "page_view_spa";
    }
    // nextjs-jobteaser
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!(document.querySelector("[data-stack=nextjs-jobteaser]") && document.querySelector("#__next"))) {
        return "page_view_next";
    }
    // default
    return "page_view";
};

//# sourceMappingURL=getPageViewCategoryAccordingToTheStack.js.map